import { memo, useMemo } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import { Typography } from "@components/atoms/typography";
import {
  dashboardCardVariants,
  dashboardColors,
} from "@components/molecules/dashboardCard/variant";
import type { IDashboardCardProps } from "@components/molecules/dashboardCard/types";
import backImg from "@/assets/images/dashboardCardBack.svg";

export const DashboardCard = memo(function DashboardCard({
  card,
}: IDashboardCardProps) {
  const { name, value, key } = card;

  const { color, icon } = dashboardCardVariants[key];
  const colorValue = useMemo(() => dashboardColors[color], [color]);

  const valueText = useMemo(() => `${value} +`, [value]);

  return (
    <div
      style={{
        background: `url(${backImg}), ${colorValue}`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      className={clsx(classes.card)}
    >
      <div>{icon}</div>
      <div>
        <Typography
          fontWeight={"semi-bold"}
          color={"white"}
          fontFamily={"dana"}
        >
          {name}
        </Typography>
      </div>
      <div>
        <Typography
          fontWeight={"semi-bold"}
          color={"white"}
          fontFamily={"Morabba"}
        >
          {valueText}
        </Typography>
      </div>
    </div>
  );
});
